export const DATE_FORMAT = 'MMMM D, YYYY';

export const btnPrimary = 'bg-green text-white';
export const btnOutlinePrimary =
  'border-solid border-[1px] border-green text-green';
